import React, { useState } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';

import { DeleteCellProps } from './types';
import { ModalDeleteAssignor } from '../modalDeleteAssignor';
import { useSupplierContext } from 'contexts/complementaryRegistration';
import { IconButton, Tooltip } from '@material-ui/core';

export const DeleteCell = ({ row, personIdLogged }: DeleteCellProps) => {
  const [showModalDelete, setShowModalDelete] = useState(false);
  const handleOpenDeleteModal = () => setShowModalDelete(true);
  const handleCloseDeleteModal = () => setShowModalDelete(false);
  const { supplierData } = useSupplierContext();
  const disableDelete = supplierData.assignors.filter(({ operation }) => operation !== 'E').length === 1;

  return (
    <>
      <ModalDeleteAssignor
        row={row}
        open={showModalDelete}
        handleClose={handleCloseDeleteModal}
        personIdLogged={personIdLogged}
      />
      <Tooltip title={disableDelete ? 'É obrigatório manter ao menos um cedente cadastrado!' : ''}>
        <span>
          <IconButton onClick={() => handleOpenDeleteModal()} disabled={disableDelete} style={{ cursor: 'pointer' }}>
            <DeleteIcon />
          </IconButton>
        </span>
      </Tooltip>
    </>
  );
};
